import "./bootstrap";
import "../css/app.css";

import { createApp, h, provide } from "vue";
import { createInertiaApp, router } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { i18nVue } from "laravel-vue-i18n";
import mitt from "mitt";
import VueTheMask from "vue-the-mask";
import { ZiggyVue } from "ziggy-js/dist/vue.m";
import { DefaultApolloClient } from "@vue/apollo-composable";
import apolloClient from "@/apolloClient";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/vue";
import { Ziggy } from "./ziggy";
import KeystrokeJsonDetector from "@/Helpers/KeystrokeJsonDetector";
import ScannerEventDetector from "@/Helpers/ScannerEventDetector";

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText ||
    "Van Rijn Coating";
const emitter = mitt();

window.addEventListener("popstate", () => {
    window.location.reload();
});

router.on("before", (event) => {
    const { url } = event.detail.visit;
    const storedPerPage = localStorage.getItem(`perPage:${url.pathname}`);
    if (storedPerPage && !url.searchParams.has("page[size]")) {
        url.searchParams.set("page[size]", storedPerPage);
    }
    try {
        const ordersIndexPath = new URL(route("orders.index")).pathname;
        if (url.pathname === ordersIndexPath) {
            sessionStorage.removeItem("orderIndexFilters");
        }
    } catch {}
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({
            setup: () => {
                provide("emitter", emitter);
                provide(DefaultApolloClient, apolloClient);
            },
            render: () => h(App, props),
        })
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(i18nVue, {
                resolve: async (lang) => {
                    const langs = import.meta.glob("../../lang/php_*.json");
                    if (lang) {
                        return langs[`../../lang/php_${lang}.json`]();
                    }

                    return langs[`../../lang/php_nl.json`]();
                },
            })
            .use(VueTheMask)
            .mount(el);

        Sentry.init({
            app,
            dsn: "",
            environment: "production",
            tracesSampleRate: 1.0,
            trackComponents: true,
            logErrors: true,
            integrations: [new BrowserTracing()],
        });

        return app;
    },
});

const scannerEventDetector = new ScannerEventDetector((event) => {
    emitter.emit("scannerEvent", event);
});

// eslint-disable-next-line no-new
new KeystrokeJsonDetector((jsonData) => {
    scannerEventDetector.handleScannerInput(jsonData);
});
